import { dashboardService } from '../../../network';
import {
  GET_DASHBOARD,
  GET_PERIOD_DATE_FILTER_DASHBOARD,
  SET_DASHBOARD,
  SET_PERIOD_DATE_FILTER_DASHBOARD,
  FETCH_DASHBOARD,
  SAVE_PERIOD_DATE_FILTER_DASHBOARD,
  SAVE_DATE_FILTER_DASHBOARD,
  SET_DATE_FILTER_DASHBOARD,
  GET_DATE_FILTER_DASHBOARD
} from './types';

const store = {};
let latestRequest = 0;

const getDefaultState = () => ({
  dashboard: {},
  date_range_filter: [],
  date_filter: ''
});

store.state = getDefaultState();

store.getters = {
  [GET_DASHBOARD]: (state) => state.dashboard,
  [GET_PERIOD_DATE_FILTER_DASHBOARD]: (state) => state.date_range_filter,
  [GET_DATE_FILTER_DASHBOARD]: (state) => state.date_filter
};

store.mutations = {
  [SET_DASHBOARD](state, payload) {
    state.dashboard = payload;
  },
  [SET_PERIOD_DATE_FILTER_DASHBOARD](state, payload) {
    state.date_range_filter = payload;
  },
  [SET_DATE_FILTER_DASHBOARD](state, payload) {
    state.date_filter = payload;
  }
};

store.actions = {
  async [FETCH_DASHBOARD]({ commit }, params) {
    const requestId = ++latestRequest;
    try {
      const data = await dashboardService.getDashboard(params);
      if (requestId !== latestRequest) return null;

      commit(SET_DASHBOARD, data);
      return data;
    } catch (error) {
      if (requestId === latestRequest) throw error;
      return null;
    }
  },
  [SAVE_PERIOD_DATE_FILTER_DASHBOARD]({ commit }, payload) {
    commit(SET_PERIOD_DATE_FILTER_DASHBOARD, payload);
  },
  [SAVE_DATE_FILTER_DASHBOARD]({ commit }, payload) {
    commit(SET_DATE_FILTER_DASHBOARD, payload);
  }
};

export default store;
